/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  // GK-HUB: Admin set password directly (ISPs sem SMTP)
  setPassword(agentId, password) {
    return axios.put(`${this.url}/${agentId}/set_password`, { password });
  }
}

export default new Agents();
